export { SDK_SERVICE_KEY } from '@or-sdk/sdk-api';
export var UserRoles;
(function (UserRoles) {
    UserRoles["guest"] = "GUEST";
    UserRoles["user"] = "USER";
    UserRoles["admin"] = "ADMIN";
    UserRoles["superAdmin"] = "SUPER_ADMIN";
})(UserRoles || (UserRoles = {}));
//# sourceMappingURL=constants.js.map